module.exports = __webpack_public_path__ + "static/img/indexText6.fec8aa2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText6.png
// module id = Jraq
// module chunks = 1